module.exports = __webpack_public_path__ + "static/media/wetsand3.3ea87745.svg";